(() => {
  'use strict';
  const calculator = document.getElementById('scf-calculator');
  if (calculator) window.addEventListener('message', event => {
    if (event.source !== calculator.contentWindow || event.data?.type !== 'scf-calculator-size') return;
    const height = event.data.height;
    if (typeof height === 'number' && Number.isFinite(height) && height >= 250 && height <= 4000) calculator.style.height = Math.ceil(height) + 'px';
  });
  const search = document.getElementById('learn-search');
  const articles = [...document.querySelectorAll('[data-article-topic]')];
  const buttons = [...document.querySelectorAll('[data-topic]')];
  let selected = 'all';
  function filter() {
    const query = search.value.trim().toLocaleLowerCase();
    let count = 0;
    articles.forEach(article => {
      const visible = (selected === 'all' || selected === article.dataset.articleTopic) && article.textContent.toLocaleLowerCase().includes(query);
      article.hidden = !visible;
      if (visible) count += 1;
    });
    const status = document.getElementById('learn-count');
    status.textContent = count + ' ' + status.dataset.label;
    document.getElementById('learn-empty').hidden = count > 0;
  }
  if (search) {
    search.addEventListener('input', filter);
    buttons.forEach(button => button.addEventListener('click', () => {
      selected = button.dataset.topic;
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      filter();
    }));
    filter();
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed() !== true) return;
    const url = new URL(anchor.href, location.href);
    const screen = document.querySelector('[data-screen]')?.dataset.screen || 'other';
    let eventName;
    if (url.hostname === 'mealprepkingz.com') eventName = 'scf_mpk_click';
    else if (['www.instagram.com','www.facebook.com','twitter.com','x.com'].includes(url.hostname)) eventName = 'scf_social_click';
    else if (['mailto:','tel:'].includes(url.protocol)) eventName = 'scf_contact_click';
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];
    const destination = url.protocol === 'https:' ? url.origin + url.pathname + url.hash : url.protocol;
    window.dataLayer.push({event:eventName,scf_page:screen,scf_destination:destination,scf_cta:anchor.dataset.scfCta || 'link'});
  });
})();
